export default __webpack_public_path__ + "assets/b5f00f4773c549fdd8d5b6538fe3c17e.png";